module.exports = __webpack_public_path__ + "src/img/artist/artist01.jpg?d5390978a5ad43280c2fe9331a253884";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artist01.jpg
// module id = 107
// module chunks = 0